module.exports = __webpack_public_path__ + "img/4.dc867ca5.jpg";